import { combineReducers } from 'redux'
import * as constants from './constants'
import * as grsConstants from 'grs/constants'
import { CLEAR_BASKET } from 'basket/constants'
import { LOGOUT } from 'auth/constants'

const rates = (state = [], { type, rates }) => (type === constants.SET_RATES ? rates : state)

const selectedRate = (state = null, action) => {
    switch (action.type) {
        case constants.SELECT_RATE:
            return action.selectedRateId
        case constants.CLEAR_SELECTED_RATE:
        case constants.EXIT_BOOKING_FLOW:
        case CLEAR_BASKET:
            return null
        default:
            return state
    }
}

const selectedVehicles = (state = [], { type, selectedVehicles, vehicle }) => {
    switch (type) {
        case constants.SET_SELECTED_VEHICLE:
            if (!selectedVehicles) {
                return []
            }

            if (Array.isArray(selectedVehicles)) {
                return selectedVehicles
            } else {
                return [selectedVehicles]
            }

        case constants.REMOVE_FROM_SELECTED_VEHICLES:
            return state.filter($vehicle => $vehicle.id !== vehicle.id)
        case LOGOUT:
            return []
        default:
            return state
    }
}

const card = (state = null, payload) => {
    switch (payload.type) {
        case constants.SET_SELECTED_CREDIT_CARD:
            return payload.card
        case LOGOUT:
            return null
        default:
            return state
    }
}

const rawPromoCode = (state = '', { type, value }) => {
    switch (type) {
        case constants.SET_RAW_PROMO_CODE:
            return value
        case constants.CLEAR_LAST_BOOKING_DETAILS:
        case CLEAR_BASKET:
        case constants.EXIT_BOOKING_FLOW:
            return ''

        default:
            return state
    }
}

const lastBookingDetails = (
    state = null,
    { type, grsId, rateId, subscriptions, waitingListKey, rate, id, promoCode, autoRenew }
) => {
    switch (type) {
        case constants.SET_LAST_BOOKING_DETAILS:
            return {
                ...state,
                grsId,
                rateId,
                subscriptions,
                waitingListKey,
                rate,
                id,
            }

        case constants.LAST_BOOKING_SET_AUTO_RENEW:
            return {
                ...state,
                autoRenew,
            }

        case constants.LAST_BOOKING_REDEEMED_PROMO_CODE:
            return {
                ...state,
                promoCode,
            }

        case constants.LAST_BOOKING_REMOVE_PROMO_CODE:
        case constants.SET_PARKING_MODE:
            return {
                ...state,
                promoCode: undefined,
            }

        case constants.CLEAR_LAST_BOOKING_DETAILS:
        case CLEAR_BASKET:
        case constants.EXIT_BOOKING_FLOW:
        case constants.CLEAR_SELECTED_RATE:
            return null
        default:
            return state
    }
}

const bookingLocationDetails = (state = {}, { type, locationDetails }) => {
    switch (type) {
        case constants.SET_BOOKING_LOCATION_DETAILS:
            return locationDetails
        case CLEAR_BASKET:
        case constants.EXIT_BOOKING_FLOW:
            return {}
        default:
            return state
    }
}

export const CARDS = {
    SELECT_PARKING_TIME: 'SELECT_PARKING_TIME',
    AVAILABLE_PRODUCTS: 'AVAILABLE_PRODUCTS',
    CONFIRM_VEHICLE: 'CONFIRM_VEHICLE',
    PAY_FOR_PARKING: 'PAY_FOR_PARKING',
}

export const disabledCardsInitialState = {
    SELECT_PARKING_TIME: true,
    AVAILABLE_PRODUCTS: true,
    CONFIRM_VEHICLE: true,
    PAY_FOR_PARKING: true,
}

const disabledCards = (state = disabledCardsInitialState, { type, cards }) => {
    switch (type) {
        case constants.ENABLE_CARD:
            return cards.reduce((acc, key) => ({ ...acc, [key]: false }), state)
        case constants.CLEAR_SELECTED_RATE:
        case constants.EXIT_BOOKING_FLOW:
            return disabledCardsInitialState
        default:
            return state
    }
}

const seasonTickets = (state = [], { type, seasonTickets }) => {
    switch (type) {
        case grsConstants.RECEIVED_SEASON_TICKETS:
            return seasonTickets
        default:
            return state
    }
}

const selectedSeasonTicketDefaultState = { ticket: null, rate: null }

const selectedSeasonTicket = (state = selectedSeasonTicketDefaultState, { type, ticket, rate }) => {
    switch (type) {
        case constants.SELECT_SEASON_TICKET:
            return { ...state, ticket }
        case constants.RECEIVED_SELECTED_SEASON_TICKET_RATE:
        case constants.RECEIVED_WAITING_LIST_RATE:
            return { ...state, rate }
        case constants.CLEAR_SELECTED_RATE:
        case constants.EXIT_BOOKING_FLOW:
            return selectedSeasonTicketDefaultState
        default:
            return state
    }
}

const parkingMode = (state = null, { type, searchMode }) => (type === constants.SET_PARKING_MODE ? searchMode : state)

const waitingListKey = (state = null, { type, waitingListKey }) => {
    switch (type) {
        case grsConstants.VALIDATED_WAITING_LIST_KEY:
            return waitingListKey
        case constants.EXIT_BOOKING_FLOW:
        case constants.CLEAR_SELECTED_RATE:
            return null
        default:
            return state
    }
}

const waitingListNextAvailableDate = (state = null, { type, rate }) => {
    switch (type) {
        case constants.RECEIVED_WAITING_LIST_RATE:
            return rate.fromDate
        case constants.EXIT_BOOKING_FLOW:
        case constants.CLEAR_SELECTED_RATE:
            return null
        default:
            return state
    }
}

const upSellOptions = (state = null, { type, upsellOptions }) => {
    switch (type) {
        case constants.SET_UPSELL_OPTIONS:
            return upsellOptions
        case constants.FAILED_TO_FETCH_UPSELL_OPTIONS:
            return upsellOptions
        default:
            return state
    }
}

const additionalParkingItems = (state = null, { type, additionalItems }) => {
    switch (type) {
        case constants.SET_ADDITIONAL_PARKING_ITEMS:
            return additionalItems
        case constants.GET_ADDITIONAL_PARKING_ITEMS_ERROR:
            return additionalItems
        default:
            return state
    }
}

const selectedUpSellOption = (state = null, { type, selectedOption }) => {
    switch (type) {
        case constants.SELECT_UPSELL_RATE:
            return selectedOption
        case constants.CLEAR_SELECTED_UPSELL_RATE:
            return null
        default:
            return state
    }
}

const qrCodeData = (state = null, { type, qrCodeData: data }) => {
    switch (type) {
        case constants.SET_QR_CODE_DATA:
            return data
        default:
            return state
    }
}

const threeDs = (state = null, { type, challengeURL3DS, challengeData3DS }) => {
    switch (type) {
        case constants.VERIFY_3DS:
            return {
                ...state,
                challengeURL3DS,
                challengeData3DS,
            }
        case constants.DISCARD_3DS: {
            return null
        }
        default:
            return state
    }
}

const guestUserChekoutData = (state = null, { type, data, error }) => {
    switch (type) {
        case constants.SET_GUEST_USER_PERSONAL_DETAILS:
            return { ...state, guestUserPersonalData: data }
        case constants.VERIFY_GUEST_USER_SUCCESS:
            return {
                ...state,
                guestUserCardIsVerified: data,
            }
        case constants.VERIFY_GUEST_USER_FAILED:
            return {
                ...state,
                guestUserCardIsVerifiedFailed: error,
            }
        case constants.VERIFY_GUEST_USER_RESET:
            return { ...state, guestUserCardIsVerified: null, guestUserCardIsVerifiedFailed: null }
        default:
            return state
    }
}

export const booking = combineReducers({
    rates,
    selectedRate,
    card,
    lastBookingDetails,
    bookingLocationDetails,
    disabledCards,
    selectedVehicles,
    seasonTickets,
    selectedSeasonTicket,
    parkingMode,
    rawPromoCode,
    waitingListKey,
    waitingListNextAvailableDate,
    upSellOptions,
    selectedUpSellOption,
    additionalParkingItems,
    qrCodeData,
    threeDs,
    guestUserChekoutData,
})
